import { render, staticRenderFns } from "./BasketModal.vue?vue&type=template&id=29968261&scoped=true"
import script from "./BasketModal.vue?vue&type=script&lang=js"
export * from "./BasketModal.vue?vue&type=script&lang=js"
import style0 from "./BasketModal.vue?vue&type=style&index=0&id=29968261&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29968261",
  null
  
)

export default component.exports